<template>
	<section class='leaveStu' id='gwlz'>


			<!-- <Input search enter-button placeholder="..." size='small' class='searchFile' /> -->

		<!-- 	<Tabs v-model="listtabname"   @on-click='switchFileType' style='height:100%;margin-top:10px;width:95%;margin:50 auto;'>
				<TabPane label="评论" name="weiyue"> -->
        <section id='topview'>
          <ol class='tabnavs'>
              <li  @click='switchFileType(0)' :class='[curIndex==0?"active":""]'>主评论</li>
              <li  @click='switchFileType(1)' :class='[curIndex == 1?"active":""]'>子评论</li>
          </ol>

            <div class='menubtn' v-if='curIndex == 0'>
              <Button type="success" @click='addItem'>审核通过</Button>

              <Button type="info" @click='removeItem'>审核不通过</Button>
            </div>
            <div class='menubtn' v-if='curIndex == 1'>
              <Button type="success" @click='addreplayItem'>审核通过</Button>

              <Button type="info" @click='removereplayItem'>审核不通过</Button>
            </div>

        </section>

        <ul>
          <li v-if='curIndex == 0'>
           <tablePage border :queryData="queryData" :searchParam='searchParam' @selectLcd='selectLcd' :issearch='issearch'
              ></tablePage>

          </li>
         <li v-if='curIndex == 1'>
              <!-- <tablePage border :queryData="queryyyData" :searchParam='searchParam' @selectLcd='selectLcded' :issearch='isyysearch'></tablePage> -->
              <Table border ref="selection" :columns="queryyyData[1]" @on-selection-change='selectTable' :data="replayToData"></Table>
          </li>
        </ul>


			<!-- 	</TabPane>
				<TabPane label="回复评论" name="yiyue"> -->


			<!-- 	</TabPane>
			</Tabs> -->


	</section>

</template>

<script>
	// import vuetree from "vue-giant-tree"
  import tablePage from './tablePage'
	export default {
		name: 'gwlz',
		components: {
      tablePage
		},
		data() {
			return {
        replayToData:[],
        curIndex:0,
        curRatInfo:{},
        upLV:false,
        searchParam:{},
				listtabname:'weiyue',// tab切换name
       	contentHeight:40,
        issearch:-1,
        isyysearch:-1,
        selectList: [],
        queryyyData:['commentReplyManager/getQueryList',[
          {
              type: 'selection',
              width: 60,
              align: 'center'
            },
          {
            title:'一级评论',
            key:'precomment',
            render:(h,params)=>{
              return h('span',decodeURIComponent(params.row.precomment))
            }
          },
          {
            title:'二级评论',
            key:'comment',
            render:(h,params)=>{
              return h('span',decodeURIComponent(params.row.comment))
            }
          },
          {
            title:'添加人',
            width:200,
            key:'addusername',
            render:(h,params)=>{
              return h('span',decodeURIComponent(params.row.addusername))
            }
          },
          {
            title:'添加时间',
             width:150,
            key:'addtime',
            render:(h,params)=>{
              var time = params.row.addtime
              if(time.indexOf('.0')>-1){
              	time = time.split('.0')[0]
              }
              var year = new Date().getFullYear()
              if(time.indexOf(year)>-1){
              	time =  time.split(year+'-')[1]
              }
              return   h('span',time)

            }
          },
        ]],
        queryData: ['commentManager/getQueryList',[
          {
              type: 'selection',
              width: 60,
              align: 'center'
            },
          {
            title:'标题',
            key:'title',
          },
          {
            title:'评论内容',
            key:'comment',
            render:(h,params)=>{
              return h('span',decodeURIComponent(params.row.comment))
            }
          },
          {
            title:'添加人',
            width:200,
            key:'addusername',
            render:(h,params)=>{
              return h('span',decodeURIComponent(params.row.addusername))
            }
          },
          {
            title:'添加时间',
             width:150,
            key:'addtime',

          },
          // {
          //   title: '操作',
          //   slot: 'action',
          //   width: 110,
          //   align: 'center',
          //   render: (h, params) => {
          //     return h('div', [
          //       h('span', {
          //         style: {
          //           display: 'inline-block',
          //           width: '60px',
          //           height: '25px',
          //           background: '#2db7f5',
          //           borderRadius: '6px',
          //           textAlign: 'center',
          //           lineHeight: '25px',
          //           color: '#fff',
          //           fontSize: '12px',
          //           cursor: 'pointer',
          //           userSelect: 'none'
          //         },
          //         on: {
          //           click: () => {


          //             this.curRatInfo = params.row
          //             this.deleteRat(0)



          //           }
          //         }
          //       }, '编辑')
          //     ])
          //     // <span class='do' @click="show(index,row)">编辑</span>
          //   }
          // }
        ]],
			}
		},

		mounted() {

		},
		methods: {
      changeUsers(val,c,d) {
      	console.log(val,c,d)
      	this.targetUser = val
      },
      selectLcded(a) {
       this.upLV = a.length > 0 ? true : false
       this.selectList = a
     },
     selectLcd(a) {
       this.upLV = a.length > 0 ? true : false
       this.selectList = a
     },
    deleteRat(type){
      console.log(this.curRatInfo)
      var url = ''
      var param = {

      }
      if(type == 0){
        url = 'commentManager/delComment'
      }else if(type == 1){
        url = 'commentReplyManager/delComment'

      }
      this.$Modal.confirm({
          title: '提示',
          content: '<p>是否删除评论？</p>',
          onOk: () => {
              that.axios.post(url,param).then(res=>{
                console.log(res)
                 that.switchFileType(0)
              })
          },
          onCancel: () => {

          }
      });
    },
     addItem(){
        var guids = []
        var newsid = []
        var statusarr= []
        var that = this
        this.selectList.map(function(val,index){
           guids.push(val['guid'])
           newsid.push(val['newsid'])
           statusarr.push(1)
        })
        var param = {
          guid:guids.join(','),
          newsid:newsid.join(','),
          status:statusarr.join(",")
        }

        that.axios.post('commentManager/updateAuditStatus',param).then(res=>{
           console.log(res)
            that.switchFileType(0)
         })
     },
     removeItem(){
       console.log(this.selectList)
        var guids = []
        var newsid = []
        var statusarr = []
        var that = this
        this.selectList.map(function(val,index){
           guids.push(val['guid'])
           newsid.push(val['newsid'])
           statusarr.push(2)
        })
        var param = {
          guid:guids.join(','),
          newsid:newsid.join(','),
          status:statusarr.join(',')
        }
        console.log(param)
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否删除评论？</p>',
            onOk: () => {
                that.axios.post('commentManager/updateAuditStatus',param).then(res=>{
                  console.log(res)
                   that.switchFileType(0)
                })
            },
            onCancel: () => {

            }
        });
     },
     selectTable(e){
        this.selectList = e
        console.log(e)
     },


     addreplayItem(){
        var guids = []
        var newsid = []
        var commentid  = []
        var that = this
        this.selectList.map(function(val,index){
           newsid.push(1)
           commentid.push(val['commentid'])
           guids.push(val['guid'])
        })
        var param = {
          guid:guids.join(','),
          commentid:newsid.join(','),
          status:newsid.join(',')
        }
        console.log(param)

        that.axios.post('commentReplyManager/updateAuditStatus',param).then(res=>{

           that.switchFileType(1)
        })
     },
     removereplayItem(){
       console.log(this.selectList)
        var guids = []
        var newsid = []
        var commentid = []
        var that = this
        this.selectList.map(function(val,index){
           guids.push(val['guid'])
           newsid.push(2)
           commentid.push(val['commentid'])
        })
        var param = {

          guid:guids.join(','),
          commentid:commentid.join(','),
          status:newsid.join(',')
        }
        console.log(param)
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否删除评论？</p>',
            onOk: () => {
                that.axios.post('commentReplyManager/updateAuditStatus',param).then(res=>{
                  console.log(res)
                   that.switchFileType(1)
                })
            },
            onCancel: () => {

            }
        });
     },
      switchFileType(name){

        var that = this
        that.curIndex = name
      	if(name == 0){
           that.issearch = Math.random()
      	}else if(name == 1){

           that.axios.get('commentReplyManager/getQueryList',{params:{}}).then(res => {
              that.replayToData = res.data
           })

      	}

      },
			switchTab(name) {
				console.log(name)
				this.tabName= name
				var that = this
				if (name == 'liuzhuan') {
					that.axios.get('commentReplyManager/getQueryList', {
						params: {
							pguid: this.curItempGuid,
							pageno: 1,
							isread: 1
						}
					}).then((back) => {
						console.log(back)
						that.lzlist = back.data
            // that.lzlist = back.reverse()
					})

				}
			},

		},
		filters: {


		}
	}
</script>

<style scoped>
  .tabelContent {
  		margin-top: 20px;
  	}
  	.leaveStu{
  		flex:1;
  		padding-right:25px!important;
  		/* overflow: scroll; */
  		padding-bottom:50px;
  		padding-top:20px;
  		overflow-x:hidden;
  	}
 .tabnavs{
   overflow:hidden;
   cursor:pointer;
 }
 .tabnavs li{
    float:left;
    margin-right:40px;
    border-bottom:2px solid #fff;
    padding-bottom:6px;
    list-style:none;
 }
 .tabnavs li.active{
   color:#2d8cf0;
   border-bottom:2px solid #2d8cf0;
 }
#topview{
  overflow:hidden;
  width:100%;
  margin:20px auto;
  position:relative;
  z-index:1000;
}
#topview ol{
  float:left;
}
#topview .menubtn{
  float:right;
  width:180px;
  display:flex;
  justify-content: space-between;
}
	/* .ivu-transfer-list{width:40%;height:300px!important} */
</style>
